import { month } from "../action-types";

const initialState = {
  data: [],
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case month.FETCH_MONTH:
      return {
        ...state,
        isFetching: true,
      };
    case month.GET_MONTH:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
